var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2m-5.15 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56m-.25-5.56h-4.68c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m-2.34 5.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96m-4-11.96h-2.92c.95-1.66 2.49-2.94 4.32-3.56-.6 1.11-1.05 2.31-1.4 3.56m-2.92 8h2.92c.35 1.25.8 2.45 1.4 3.56-1.83-.63-3.37-1.91-4.32-3.56m-.82-2c-.16-.64-.26-1.31-.26-2s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2m4.36-9.97c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97m6.92 3.97h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.9 4.33 3.56m-6.92-6c-5.53 0-10 4.5-10 10 0 2.6521649 1.0535684 5.195704 2.92893219 7.0710678 1.87536378 1.8753638 4.41890291 2.9289322 7.07106781 2.9289322 5.5228475 0 10-4.4771525 10-10 0-2.6521649-1.0535684-5.19570403-2.9289322-7.07106781-1.8753638-1.87536379-4.4189029-2.92893219-7.0710678-2.92893219z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNb);
export default __webpack_public_path__ + "static/media/NB.247cfcb187108577b553dbf0858afbd5.svg";
export { ForwardRef as ReactComponent };